const PropTypes = require('prop-types');
const React = require('react');
const types = PropTypes;

const cx = require('classnames');

const CONTAINER_CLASSNAME = 'modal-open';

class FullScreen extends React.Component {
  static propTypes = {
    container: types.object.isRequired,
    withHeader: types.bool,
    withConfirmEmail: types.bool,
    stackedPopup: types.bool,
  };

  componentDidMount() {
    this.props.container.classList.add(CONTAINER_CLASSNAME);
  }

  componentWillUnmount() {
    this.props.container.classList.remove(CONTAINER_CLASSNAME);
  }

  render() {
    const { children, className, withHeader, withConfirmEmail, stackedPopup } = this.props;

    return (
      <div
        className={cx(
          'full-screen',
          { 'full-screen-with-header': withHeader },
          { 'full-screen-with-confirm-email': withConfirmEmail },
          { 'modal-background-dark': stackedPopup },
          className
        )}
      >
        {children}
      </div>
    );
  }
}

export default FullScreen;
